import Wix from '@wix/wix-events-commons-statics/dist/polyfills/wix-sdk'

export const setHeight = (height: number) => Wix.setHeight(height)

export const resizeComponent = (options: {width?: number; height?: number}): Promise<void> =>
  new Promise((resolve, reject) => {
    Wix.resizeComponent(options, resolve, reject)
  })

export const getSdkData = (
  key: string,
  options: {scope: 'APP' | 'COMPONENT'},
  onSuccess: Function,
  onFailure?: Function
) => Wix.Data.Public.get(key, options, onSuccess, onFailure)

export const removeSdkData = (
  key: string,
  options: {scope: 'APP' | 'COMPONENT'},
  onSuccess?: Function,
  onFailure?: Function
) => Wix.Data.Public.remove(key, options, onSuccess, onFailure)
